const id_master_supplier = {
    add: "tambah pemasok",
    address: "alamat pemasok",
    edit: "ubah pemasok",
    email: "email pemasok",
    fax: "fax pemasok",
    name: "nama pemasok",
    phone: "telepon pemasok",
    pic: "PIC pemasok",
    upload: "unggah pemasok",

    form: {
        ppn_label: "Aktifkan untuk menggunakan PPN",
        upload_title: "input data pemasok",
        coa_debit: "COA Hutang",
        coa_dp: "COA Down Payment (DP)",
    },

    message: {
        note_upload: "CATATAN : hanya format excel yang bisa diunggah !",
        note_excel: "Unduh contoh file Excel pemasok",
        note_term_title: "Ketentuan file:",
        note_term_1: "Gunakan file contoh.",
        note_term_2: "Kolom yang terdapat tanda '*' wajib diisi",
        note_term_3: "Nama Pemasok : harus diisi dan jika sudah ada di database tidak bisa diisi ulang. cth: pemasok1, pemasok2, pemasok3",
        note_term_4: "Isi kolom PPN dengan : 1 (menggunakan PPN), 0 (tidak menggunakan PPN)",
        note_term_5: "PIC : Orang yang dapat dihubungi",
    },

    error: {
        create: "Gagal membuat pemasok.",
        delete: "Gagal menghapus pemasok.",
        edit: "Gagal mengubah pemasok.",
    },

    success: {
        create: "Berhasil membuat pemasok.",
        delete: "Berhasil menghapus pemasok.",
        edit: "Berhasil mengubah pemasok.",
    },
}

export default id_master_supplier;